<template>
    <form @submit.prevent="validateForm" ref="form">
        <div v-if="postSuccessful !== null" class="messages-container">
            <div v-if="! messages.length && ! postSuccessful">
                <div class="alert alert-danger">
                    Er is een onbekende fout opgetreden
                </div>
            </div>

            <div v-for="message in messages"
                 :class='{"alert": true, "alert-success": postSuccessful, "alert-warning": ! postSuccessful}'>
                {{ message }}
            </div>
        </div>

        <div class="custom-control custom-switch text-right pb-3">
            <input type="checkbox"
                   v-model="allowDecimals"
                   value="1"
                   class="custom-control-input"
                   id="allowDecimals">
            <label class="custom-control-label custom-switch-decimals" for="allowDecimals">
                Activeer decimalen
            </label>
        </div>

        <div class="table-container">
            <div v-if="isLoading" class="js-loading-container">
                <div class="la-ball-clip-rotate js-loading la-2x"><div></div></div>
            </div>

            <table class="table table-striped table-hover display table-laps">
                <thead class="thead_wrapper">
                <tr>
                    <th class="p-3 th-medium">Brandstof</th>
                    <th class="p-3">Artikelnummer</th>
                    <th class="p-3">Voorgaande LAP</th>
                    <th class="p-3">Voorgaande LAP<br>(begindatum)</th>
                    <th class="p-3">Wijziging</th>
                    <th class="p-3">Nieuwe LAP</th>
                    <th class="p-3">Nieuwe LAP<br>(begindatum)</th>
                    <th class="p-3">Volgnummer</th>
                    <th class="p-3 no-sort"></th>
                    <th class="p-3 no-sort"></th>
                </tr>
                </thead>

                <tbody v-if="isLoaded && ! hasReviewableRows">
                <tr>
                    <td colspan="10">
                        <em>Er zijn geen LAP mutaties die door jou kunnen worden goedgekeurd</em>
                    </td>
                </tr>
                </tbody>

                <tbody v-for="(lapMutations, brandId) in lapMutationsPerBrand">
                <tr class="dtrg-group start-group">
                    <td colspan="10">{{ lapMutations[0].brand.name }}</td>
                </tr>

                <FuelLapMutationsReviewalTableRow v-for="lapMutation in lapMutations"
                                                  :key="lapMutation.id"
                                                  :allowDecimals="allowDecimals"
                                                  :lapMutation="lapMutation"
                                                  ref="reviewalRow"/>
                </tbody>
            </table>

            <div v-if="hasReviewableRows" class="row">
                <div class="col"></div>
                <div class="col-auto text-center">
                    <div class="p-3 py-4">Wijzigingen bevestigen</div>

                    <div :title="submitButtonTooltip" data-toggle="tooltip">
                        <button :disabled="!allRowsReviewed"
                                class="btn btn-red m-0 w-100 text-center"
                                type="submit">
                            Bevestig
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="same-day-alert-modal" tabindex="-1" role="dialog" aria-labelledby="same-day-alert-modal-title" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <p>De begindatum staat voor een of meer regels op vandaag. Weet je zeker dat je dit wilt
                            doorvoeren?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn m-0 text-center" data-dismiss="modal">Sluiten</button>
                        <button id="same-day-alert-modal-confirm" type="button" class="btn btn-red m-0 text-center">Toch
                            doorvoeren
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="pay-attention-modal" tabindex="-1" role="dialog"
             aria-labelledby="pay-attention-modal-title" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <p>Het maximale brandstofwijziging-percentage van 10% is overschreden. Dit moet handmatig in
                            Navision en Extendas worden aangepast, zodat de juiste prijzen weer worden weergegeven.</p>
                    </div>
                    <div class="modal-footer">

                        <button id="pay-attention-modal-confirm" type="button" data-dismiss="modal"
                                class="btn btn-red m-0 text-center">Sluiten
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import axios from 'axios';
import FuelLapMutationsReviewalTableRow from './FuelLapMutationsReviewalTableRow'

export default {
    components: {
        FuelLapMutationsReviewalTableRow
    },

    data() {
        return {
            isLoading: false,
            isLoaded: false,
            allowDecimals: false,
            lapMutationsPerBrand: {},
                messages: [],
                postSuccessful: null
            };
        },

        mounted() {
            this.$on('loaded', this.onLoaded)
            this.getLapMutations()
        },

        computed: {
            allRowsReviewed() {
                if (!this.isLoaded) {
                    return
                }

                let numberOfReviewedRows = this.$refs.reviewalRow.filter(row => {
                    return row.isReviewed
                }).length

                return numberOfReviewedRows === this.$refs.reviewalRow.length
            },

            hasReviewableRows() {
                return Object.keys(this.lapMutationsPerBrand).length > 0
            },

            submitButtonTooltip() {
                return this.hasReviewableRows && !this.allRowsReviewed ?
                    'Een of meer regels zijn nog niet goedgekeurd of aangepast' : ''
            }
        },

        watch: {
            submitButtonTooltip(value) {
                this.$nextTick(function() {
                    $('[data-toggle="tooltip"]').tooltip(value ? 'enable' : 'dispose')
                })
            }
        },

        methods: {
            getLapMutations() {
                this.isLoading = true

                axios.get(route('admin.api.laps.reviewable'))
                    .then((response) => this.lapMutationsPerBrand = response.data)
                    .catch()
                    .then(() => this.$nextTick(() => {
                        this.isLoading = false

                        if (! this.isLoaded) {
                            this.isLoaded = true
                            this.$emit('loaded')
                        }
                    }))
            },

            onLoaded() {
                $('[data-toggle="tooltip"]').tooltip()
            },

            checkValidationPumpPrice() {
                let showAlert = this.$refs.reviewalRow.filter(row => {
                    return row.lapMutation.checked_first_time_at &&
                        (
                            row.finalLap > row.lapMutation.previous_lap * 1.1 ||
                            row.finalLap < row.lapMutation.previous_lap * 0.9
                        )

                }).length;

                if (showAlert) {
                    jQuery('#pay-attention-modal').modal();
                    jQuery('#pay-attention-modal-confirm').on('click', this.checkSameDay)
                } else {
                    console.log('else');
                    this.checkSameDay()
                }
            },

            checkSameDay() {
                console.log('checkSameDay');
                let todayInDatepickerFormat = new Date().toLocaleDateString('en-GB')

                if ($('.date').attr('placeholder') === todayInDatepickerFormat) {
                    jQuery('#same-day-alert-modal').modal()
                    jQuery('#same-day-alert-modal-confirm').on('click', this._validateForm)
                } else {
                    this._validateForm()
                }
            },

            validateForm(e) {
                if (!this.allRowsReviewed) {
                    return;
                }

                this.target = new FormData(e.target)
                this.checkValidationPumpPrice();
            },

            _validateForm() {
                let sameDayAlertModal = jQuery('#same-day-alert-modal')
                if (
                    (sameDayAlertModal.data('bs.modal') || {}).isShown // Bootstrap <= 3
                    || (sameDayAlertModal.data('bs.modal') || {})._isShown // Bootstrap 4
                )
                    sameDayAlertModal.modal('hide')

                let payAttentionModal = jQuery('#pay-attention-modal')
                if (
                    (payAttentionModal.data('bs.modal') || {}).isShown // Bootstrap <= 3
                    || (payAttentionModal.data('bs.modal') || {})._isShown // Bootstrap 4
                )
                    payAttentionModal.modal('hide')

                this.isLoading = true
                axios.post(route('admin.api.laps.review'), this.target)
                    .then((response) => {
                        this.lapMutationsPerBrand = response.data.lap_mutations || []
                        this.messages = response.data.messages || []
                        this.postSuccessful = response.data.success || false
                    })
                    .catch((response) => {
                        this.messages = []
                        this.postSuccessful = false
                    })
                    .then(() => this.$nextTick(() => {
                        this.isLoading = false
                    }))
            }
        }
    }
</script>

<style lang="scss" scoped>
    button[type=submit]:disabled {
        pointer-events: none;
    }

    .js-loading-container {
        background: rgba(255, 255, 255, .73);
        display: block;
        height: 100%;
        padding: 50px 0;
        position: absolute;
        text-align: center;
        top: 0;
        width: 100%;
        z-index: 10;
    }

    .table-container {
        position: relative;
    }

    th {
        white-space: nowrap;
    }
</style>
